<template>
    <div class="uk-padding-small" style="background-color: #800000 ; border-top: #004e9c 3px solid">
        <div class="uk-container uk-container-xsmall">
            <div class="uk-child-width-1-1" uk-grid>
                <div>
                    <img class="uk-align-center" src="../../assets/logo.png" style="margin-top: 5%;" alt="">
                    <h4 class=" uk-light uk-text-center " style="margin-top: -25px">Aeorion Software Solutions</h4>
                </div>
            </div>
            <div class="uk-child-width-1-2@s" uk-grid>
                <div >
                    <p class="uk-light uk-text-small uk-align-right@s">
                        Northern Caribbean University, <br>
                        Manchester Road, <br>
                        Manchester, Jamaica
                    </p>
                </div>
                <div>
                    <p class="uk-light uk-text-small" >
                        Tel: <a href="tel:1-876-963-7300">1-876-963-7300</a> <br>
                        Fax: 1-876-962-0075 <br>
                        Email : <a href="mailto:support@aeorion.com">support@aeorion.com</a>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "foot"
    }
</script>

<style scoped>
    img{
        max-width: 500px !important;
        max-height: 500px !important;
        width: auto;
        height: auto;
    }
</style>